export type IdentityCardType = {
  /**
   * Enum key
   */
  code: string;
  /**
   * Translated value for enum
   */
  name: string;
};
